<template>
  <div class="container text-center">
    <!-- Process Button -->
    <button v-b-modal="'processPaymentModalFirst'" class="btn btn-primary btn-block">
      Process - {{ convertCurrencyToLocal(orderAmount) }}
    </button>

    <!-- Main Payment Modal -->
    <b-modal id="processPaymentModalFirst" hide-footer hide-title>
      <div class="text-center">
        <h1>Order Amount</h1>
        <hr />
        <h1 style="font-size: 4em; font-weight: 900;">
          {{ convertCurrencyToLocal(orderAmount) }}
        </h1>

        <!-- Toggle Split Payment -->
        <a href="#" @click.prevent="splitAmount = true">Split Amount</a>
        <div v-if="splitAmount" class="my-2">
          <input
            class="form-control text-center"
            type="number"
            v-model.number="splitAmountValue"
            placeholder="Enter amount to pay"
            required
          />
        </div>
        <hr />
      </div>

      <!-- M-Pesa Polling Loader -->
      <div v-if="mpesaLoaderAwait" class="text-center my-3">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p>Waiting for M-Pesa confirmation...</p>
        <a
          href="#"
          class="d-block text-muted small"
          @click.prevent="processMpesaNoValidation(paymentMethod, splitAmount ? splitAmountValue : orderAmount)"
        >
          Skip Validation
        </a>
      </div>

      <!-- M-Pesa Matching Transactions -->
      <div v-if="customersPayment.length > 0">
        <table class="table table-hover">
          <tbody>
            <tr
              v-for="payment in customersPayment"
              :key="payment.id"
              @click="completeMpesaPayment(orderId, payment.id)"
              style="cursor: pointer"
            >
              <td><small>{{ payment.customer }}</small></td>
              <td><small>{{ payment.transaction_code }}</small></td>
              <td><small>{{ convertCurrencyToLocal(payment.amount) }}</small></td>
              <td><i class="bi bi-check-circle text-success"></i></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Payment Options -->
      <div class="btn-group w-100 mb-3">
        <a
          v-for="paymentGateway in paymentGateways"
          :key="paymentGateway.id"
          @click="checkoutPayment(paymentGateway.id, paymentGateway.payment_method)"
          :class="paymentGateway.payment_method === 'M-pesa' ? 'btn-success' : 'btn-outline-primary'"
          class="btn text-capitalize btn-sm"
        >
          {{ paymentGateway.payment_method }}
        </a>
      </div>

      <!-- Errors -->
      <div v-if="submittingError" class="alert alert-danger" role="alert">
        {{ submittingError }}
      </div>
      <div v-if="paymentProcessingError" class="alert alert-warning" role="alert">
        {{ paymentProcessingError }}
      </div>
    </b-modal>

    <!-- Cash Payment Modal -->
    <b-modal ref="paidAmountmodal" hide-footer hide-title>
      <div class="container py-3">
        <!-- Cash Amount Input -->
        <div class="row align-items-center mb-3">
          <div class="col-md-6">
            <h5 class="text-primary mb-0">Cash Amount</h5>
            <small class="text-muted">Amount of cash received from the customer</small>
          </div>
          <div class="col-md-6">
            <input
              class="form-control border-0 border-bottom"
              v-model.number="paidAmount"
              type="number"
              placeholder="Enter cash received"
              required
            />
          </div>
        </div>

        <!-- Order Amount Display -->
        <div class="row align-items-center mb-3">
          <div class="col-md-6">
            <h5 class="text-primary mb-0">Order Amount</h5>
            <small class="text-muted">Total amount of the order</small>
          </div>
          <div class="col-md-6">
            <input
              class="form-control border-0 border-bottom bg-light"
              :value="convertCurrencyToLocal(orderAmount)"
              readonly
            />
          </div>
        </div>

        <!-- Change to Give -->
        <div class="row align-items-center mb-4">
          <div class="col-md-6">
            <h5 class="text-primary mb-0">Change</h5>
            <small class="text-muted">Amount to return to the customer</small>
          </div>
          <div class="col-md-6">
            <div v-if="changeToCustomer > 0">
              <button class="btn btn-outline-success btn-block">
                {{ convertCurrencyToLocal(changeToCustomer) }}
              </button>
            </div>
            <div v-else>
              <span class="text-muted">No change to return</span>
            </div>
          </div>
        </div>

        <!-- Confirm Button -->
        <div class="text-right">
          <button class="btn btn-primary" @click="processCashPayment()">Confirm Payment</button>
        </div>
      </div>
    </b-modal>
        <b-modal ref="selected_bnpl_customer_modal" hide-footer>
        <div>
            <p>Type to start searching customer</p>
            <div class="input-group">

        <input v-model=" customerData.searchTerm" type="text" class="form-control" placeholder="Search by name, email, or phone number">
        </div>
        <ul class="my-3" v-if="customerData.allcustomers.length > 0">
        <li v-for="customer in customerData.allcustomers" :key="customer.id"  @click="selectBNPLCustomer(customer)">
            {{ customer?.full_name }} - {{ customer?.phone }}
            <hr class="m-0 my-1" />
        </li>
        </ul>

        </div>
        </b-modal>
        <b-modal ref="bnpl_modal" hide-footer>
            <div class="text-center"><h5>Buy Now Pay Later Details</h5></div>
            <small v-if="bnplForm.customerError !==''" class="text-danger">{{ bnplForm.customerError }}</small>
            <form @submit.prevent="processBNPLPayment()">

                <div class="form-group">
                    <label>Customer Details</label>
                    <input v-if="bnplForm.orderDetails.customer?.full_name" type="text" class="form-control" v-model="bnplForm.orderDetails.customer.full_name" placeholder="Customer Name/Phone/Email" readonly/>
                    <p v-if="bnplForm.orderDetails?.customer"><a href="#" @click="selectedBNPLCustomerModal">Select Customer</a></p>
                    <p v-if="bnplForm.orderDetails?.customer"><a href="#" @click="selectedBNPLCustomerModal">Select To Change Customer</a></p>
                </div>
                <div class="form-group">
                    <label>Total Amount</label>
                    <input type="integer" class="form-control" v-model="bnplForm.orderDetails.balance" readonly/>

                </div>
                <div class="form-group">
                    <label>Deposit</label>
                    <input type="integer" class="form-control" v-model="bnplForm.depositAmount" />

                </div>
                <div class="form-group">
                    <label>Due Date</label>
                    <b-form-datepicker v-model="bnplForm.dueDate" :min="bnplForm.minimumDate" class="form-control" required></b-form-datepicker>

                </div>
                <div class="form-group">

                    <button type="submit" class="btn btn-outline-primary btn-block">Process BNPL</button>

                </div>

            </form>
        </b-modal>
  </div>
</template>



<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
export default {
  name: "MiniCheckout",

  data() {
     const now = new Date()
     const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
     const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth() - 2)
            minDate.setDate(15)
    return {
      paymentGateways: [],
      selectedModeOfPayment: '',
      orderId: '',

      submittingError: '',
      paymentProcessingError: '',
      mpesaLoaderAwait: false,
      paymentMethod: false,
    checkmpesaresponsepoll: null,
    customersPayment:[],
     paidAmount: 0,
    changeToCustomer: 0,
    splitAmount:false,
    customerData: {
                    searchTerm: '',
                    allcustomers: [],
                    filteredCustomers: []
                },
    splitAmountValue:0,
    createdOrderDetails:{},
     bnplForm: {
                    dueDate: '',
                    depositAmount: 0.00,
                    interest: false,
                    minimumDate: minDate,
                    paymentId: '',
                    customerError: '',
                    orderDetails: {
                        customer: {
                            full_name: ''
                        }
                    }
                },

    }
  },
  computed: {

         ...mapGetters(['userDetails']),
        orderAmount() {
        return this.$store.state.totalOrderAmount
    },
  },
  mounted() {
    this.getPaymentGateways()

  },
    watch: {
            paidAmount(before, after) {
                this.changeToCustomer = this.paidAmount - this.orderAmount;
            }

        },
  methods: {
  async checkoutPayment(id, mode) {
    this.selectedModeOfPayment = id
    this.paymentMethod = mode

    await this.submitData()
  },
selectedBNPLCustomerModal() {
                this.$refs.selected_bnpl_customer_modal.show()
            },
   async processBNPLPayment() {
                if (this.bnplForm.orderDetails.customer !== null) {

                    await axios.post('/api/pay-via-bnpl', { ...this.bnplForm
                    }).then(results => {
                        if (results.status == 200) {

                            this.redirectAfterPayment(this.bnplForm.orderDetails)
                        }
                    }).catch(err => {
                        this.$refs.bnpl_modal.hide()
                        this.$toasts.push({
                            type: 'error',
                            message: "An error occured creating your order !"
                        })
                    })
                } else {
                    this.bnplForm.customerError = 'You need to select a customer'
                }
            },

  async submitData() {
    if (this.orderId) {
      return await this.routePayment()
    }

    const data = {
      cart: JSON.stringify(this.$store.state.cart),
      customerdata: JSON.stringify(this.$store.state.customerdata),
      totalprice: JSON.stringify(this.$store.state.totalOrderAmount),
      discount: 0,
      addTo: false
    }

    try {
      const result = await axios.post('/api/order', data)
      this.orderId = result.data.id
      this.createdOrderDetails = result.data
      this.bnplForm.orderDetails = result.data
    //   this.$store.commit('setTotalOrderAmount', result.data.order.total_amount)
      await this.routePayment()
    } catch (error) {
        console.log(error)
      this.submittingError = error
    }
  },

  async routePayment() {
    const method = this.paymentMethod?.toLowerCase()
    const amount = this.splitAmount ? this.splitAmountValue : this.orderAmount

    if (this.splitAmount) {
      await this.processSplitPayment(method, amount)
    } else {
      await this.processFullPayment(method, amount)
    }
  },

  async processFullPayment(method, amount) {
    switch (method) {
      case 'm-pesa':
        this.mpesaLoaderAwait = true
        this.checkmpesaresponsepoll = setInterval(async () => {
          try {
            const checkerresults = await axios.get('/api/validate-transaction', {
              params: { expected_amount: amount }
            })

            if (
              checkerresults.status === 200 &&
              checkerresults.data.transaction_type === 'sms' &&
              checkerresults.data.transaction.length > 0
            ) {
              this.customersPayment = checkerresults.data.transaction
              this.mpesaLoaderAwait = false
              setTimeout(() => clearInterval(this.checkmpesaresponsepoll), 3000)
            }
          } catch (error) {
            console.error('Polling error:', error)
          }
        }, 5000)
        break

      case 'cash':
        this.$refs['paidAmountmodal'].show()
        break

      case 'buy now pay later':

        this.bnplForm.paymentId = this.selectedModeOfPayment,
        this.bnplForm.orderDetails.customer = this.$store.state.customerdata,
        this.bnplForm.orderDetails.balance = amount

        this.$refs.bnpl_modal.show()
        break

      default:
        try {
          const result = await axios.post('/api/full-payment', {
            paymentMethod: this.selectedModeOfPayment,
            amount: this.orderAmount,
            orderId: this.orderId
          })
          if (result.status === 200) {
            this.redirectAfterPayment(result.data)
          }
        } catch (error) {
          this.paymentProcessingError = error.response?.data?.message || 'Payment failed'
        }
        break
    }
  },

  async processCashPayment() {
    try {
      const result = await axios.post('/api/full-payment', {
        paymentMethod: this.selectedModeOfPayment,
        amount: this.orderAmount,
        orderId: this.orderId
      })
      if (result.status === 200) {
        this.redirectAfterPayment(result.data)
      }
    } catch (error) {
      this.paymentProcessingError = error.response?.data?.message || 'Payment failed'
    }
  },

  async processSplitPayment(method, amount) {

    switch (method) {
      case 'm-pesa':

        this.mpesaLoaderAwait = true
        this.checkmpesaresponsepoll = setInterval(async () => {
          try {
            const checkerresults = await axios.get('/api/validate-transaction', {
              params: { expected_amount: amount }
            })

            if (
              checkerresults.status === 200 &&
              checkerresults.data.transaction_type === 'sms' &&
              checkerresults.data.transaction.length > 0
            ) {
              this.customersPayment = checkerresults.data.transaction
              this.mpesaLoaderAwait = false
              setTimeout(() => clearInterval(this.checkmpesaresponsepoll), 3000)
            }
          } catch (error) {
            console.error('Polling error:', error)
          }
        }, 5000)
        break

      case 'cash':
        try {
          const results = await axios.post('/api/split-payment', {
            paymentMethod: this.selectedModeOfPayment,
            amount: amount,
            orderId: this.orderId
          })

          if (results.status === 200) {
            const link = this.userDetails?.company?.companysettings?.skip_checkout_done
              ? `/print_invoice/${results.data.id}`
              : `/paid/view-order-details/${results.data.id}`

            if (results.data.balance === 0) {
              window.location.replace(link)
            } else {
              this.splitAmount = true
              this.splitAmountValue = results.data.balance
            }
          }
        } catch (error) {
          console.error(error.response?.data?.message || 'Split payment failed')
        }
        break

      default:
        try {
          const result = await axios.post('/api/split-payment', {
            paymentMethod: this.selectedModeOfPayment,
            amount: amount,
            orderId: this.orderId
          })

          if (result.status === 200 && result.data.balance === 0) {
             const link = this.userDetails?.company?.companysettings?.skip_checkout_done
              ? `/print_invoice/${result.data.id}`
              : `/paid/view-order-details/${result.data.id}`
              window.location.replace(link)
            } else {
              this.mpesaLoaderAwait = false
              this.splitAmount = true
              this.splitAmountValue = result.data.balance
            }

        } catch (error) {
          this.paymentProcessingError = error
        }
        break
    }
  },

  async completeMpesaPayment(order, payment) {
    try {
      const results = await axios.post('/api/order-mpesa-payment-validate', {
        transaction_id: payment,
        orderId: order,
        paymentMethod: this.selectedModeOfPayment,
        amount: this.splitAmount ? this.splitAmountValue : this.orderAmount
      })

      const link = this.userDetails?.company?.companysettings?.skip_checkout_done
        ? `/print_invoice/${order}`
        : `/paid/view-order-details/${order}`

      if (results.status === 200 && results.data.balance === 0) {
        this.$store.commit('resetStore')
        window.location.replace(link)
      } else {
        this.splitAmount = true
        this.splitAmountValue = results.data.balance
        this.customersPayment = []
      }
    } catch (error) {
      this.paymentProcessingError = error
    }
  },

  async processMpesaNoValidation(method, amount) {
    if (this.splitAmount) {
      await this.processSplitPayment(method, amount)
    } else {
      await this.processFullPayment(method, amount)
    }
  },

  redirectAfterPayment(orderDetails) {
    const link = this.userDetails?.company?.companysettings?.skip_checkout_done
      ? `/print_invoice/${orderDetails.id}`
      : `/paid/view-order-details/${orderDetails.id}`

    this.$store.commit('resetStore')
    window.location.replace(link)
  },

  async getPaymentGateways() {
    try {
      const results = await axios.get('/api/payments')
      this.paymentGateways = results.data
    } catch (error) {
      console.error("Error loading gateways", error)
    }
  }
}

}
</script>
